



















































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { APP_CONFIG } from '@/config/app-config';
import formatNumber from '@/shared/filters/format-number';

@Component
export default class ListReceipt extends Vue {
    @Prop({ default: () => [] })
    private listReceipt!: any[];

    @Prop({ default: () => ({}) })
    private pageSettings!: any;

    get isDepositSystem() {
        return APP_CONFIG.system_type !== 'order';
    }

    private viewDetail(receipt: any) {
        if (!receipt || !receipt.id) {
            return;
        }
        const routeData = this.$router.resolve({ name: 'receipt-detail', params: { id: receipt.id.toString() } });
        window.open(routeData.href, '_blank');
    }

    private transformNumb(value: number, format: string) {
        if (!(value > 0)) {
            return '0';
        }
        return formatNumber(value, format);
    }
}
